var aq;
(function (aq) {
    var services;
    (function (services) {
        var OptimalStartService = /** @class */ (function () {
            /* @ngInject */
            function OptimalStartService($http, resolver, Messages, AQ_API_URL, AuthToken) {
                this.$http = $http;
                this.resolver = resolver;
                this.Messages = Messages;
                this.AQ_API_URL = AQ_API_URL;
                this.AuthToken = AuthToken;
            }
            OptimalStartService.prototype.getOptimalStartById = function (id) {
                var _this = this;
                try {
                    return this.resolver(function () { return __awaiter(_this, void 0, void 0, function () {
                        var response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.$http({
                                        method: 'GET',
                                        headers: this.getHeaders(),
                                        url: this.AQ_API_URL + "optimalstart/v1/optimal/" + id
                                    })];
                                case 1:
                                    response = _a.sent();
                                    return [2 /*return*/, response.data];
                            }
                        });
                    }); });
                }
                catch (error) {
                    throw error;
                }
            };
            OptimalStartService.prototype.getHeaders = function () {
                return {
                    'Content-Type': 'application/json',
                    'Authorization': this.AuthToken
                };
            };
            return OptimalStartService;
        }());
        services.OptimalStartService = OptimalStartService;
        angular
            .module('aq.services')
            .service('OptimalStartService', OptimalStartService);
    })(services = aq.services || (aq.services = {}));
})(aq || (aq = {}));
